<h2 style="text-align:center">Final survey</h2>
<router-outlet name="survey-form"></router-outlet>